import "antd/lib/button/style";
import _Button from "antd/lib/button";
import "antd/lib/input/style";
import _Input from "antd/lib/input";
import _classCallCheck from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _defineProperty from "/Users/begin/work/boss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "antd/lib/select/style";
import _Select from "antd/lib/select"; /**
                                       * 设备流量-用户排行榜-用户流量详情-应用排名
                                       **/
import React from 'react';
import * as echarts from "echarts";
import { connect } from "dva";
import { withRouter } from "react-router-dom";
import { parse } from "../../../../../utils/commonUtilFunc";
import { chartColor, pieChartColor } from "../../../../../utils/commonConsts";
var Option = _Select.Option;
var UserAppRank = /*#__PURE__*/function (_React$Component) {
  _inherits(UserAppRank, _React$Component);
  function UserAppRank(props) {
    var _this;
    _classCallCheck(this, UserAppRank);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(UserAppRank).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "get_step_apps", function () {
      _this.props.dispatch({
        type: "ci0303Info/get_step_apps",
        payload: {
          start_tm: _this.start_tm,
          end_tm: _this.end_tm,
          tunnel_dir: _this.tunnel_dir_id,
          sn: _this.sn,
          top: _this.state.top,
          sip: _this.props.selectedUserIp,
          name: _this.state.name,
          company_id: _this.ifCompany ? _this.company_id : sessionStorage.getItem("companyId")
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "selectDataNum", function (value) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      vm.setState({
        top: value
      }, function () {
        vm.get_step_apps();
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSearchInputChange", function (e) {
      var vm = _assertThisInitialized(_assertThisInitialized(_this));
      _this.setState({
        name: e.target.value
      }, function () {
        if (_this.state.name === "") {
          vm.get_step_apps();
        }
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderChart", function (el) {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '7%',
          bottom: '10%',
          top: "5%",
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisTick: {
            show: false
          },
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: "rgba(0,0,0,0.45)"
            }
          },
          name: "MB"
        },
        yAxis: {
          type: 'category',
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: "dashed",
              color: "rgba(0,0,0,0.45)"
            }
          },
          inverse: true
        },
        series: [{
          name: '流量',
          type: 'bar',
          data: _this.props.ci0303Info.step_apps_flow,
          itemStyle: {
            normal: {
              color: function color(params) {
                return pieChartColor[params.dataIndex % chartColor.length];
              }
            }
          },
          label: {
            normal: {
              show: true,
              position: 'right'
            }
          },
          barCategoryGap: "60%",
          barMinHeight: "10",
          barMaxWidth: 32
        }],
        color: ["red", "yellow"]
      };
      el.setOption(option);
    });
    _this.state = {
      name: "",
      top: "5"
    };
    var search = parse(_this.props.location.search);
    _this.sn = search.sn;
    _this.start_tm = search.start_tm;
    _this.end_tm = search.end_tm;
    _this.tunnel_dir = search.tunnel_dir;
    _this.tunnel_dir_id = search.tunnel_dir_id;
    _this.company_id = search.id;
    _this.ifCompany = sessionStorage.getItem("role") === 'supercxpbusiness' || sessionStorage.getItem("role") === 'supercxptechnology' || sessionStorage.getItem("role") === 'supercxptechsupport' || sessionStorage.getItem("role") === "supercxpbizadmin" || sessionStorage.getItem("role") === "supercxptechadmin";
    return _this;
  }
  _createClass(UserAppRank, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.element = echarts.init(document.getElementById('user-app-rank'));
      this.get_step_apps();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.renderChart(this.element);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Select, {
        placeholder: "\u8BF7\u9009\u62E9\u6570\u636E\u6761\u6570",
        style: {
          width: 120,
          marginRight: 8,
          marginTop: 16
        },
        className: "input",
        onChange: this.selectDataNum,
        defaultValue: "5"
      }, /*#__PURE__*/React.createElement(Option, {
        value: "5"
      }, "@5\u6761"), /*#__PURE__*/React.createElement(Option, {
        value: "10"
      }, "@10\u6761"), /*#__PURE__*/React.createElement(Option, {
        value: "15"
      }, "@15\u6761"), /*#__PURE__*/React.createElement(Option, {
        value: "20"
      }, "@20\u6761")), /*#__PURE__*/React.createElement(_Input, {
        placeholder: "\u8BF7\u8F93\u5165\u5173\u952E\u5B57",
        style: {
          width: 240,
          marginRight: 8
        },
        className: "input",
        onChange: this.handleSearchInputChange
      }), /*#__PURE__*/React.createElement(_Button, {
        onClick: this.get_step_apps
      }, "\u641C\u7D22"), /*#__PURE__*/React.createElement("div", {
        id: "user-app-rank",
        style: {
          width: 900,
          height: 400
        }
      }));
    }
  }]);
  return UserAppRank;
}(React.Component);
function mapDispatchToProps(_ref) {
  var ci0303Info = _ref.ci0303Info;
  return {
    ci0303Info: ci0303Info
  };
}
export default connect(mapDispatchToProps)(withRouter(UserAppRank));